import { Box } from "@vapor/react-material";
import Typography from "@vapor/react-extended/ExtendedTypography";

export const SustainablePlatform = () => (
    <Box marginBottom="24px">
        <Typography
            variant="titleLarge"
            color="#152935"
        >
            La piattaforma semplice e sostenibile per la gestione dei processi digitali.
        </Typography>
    </Box>
);
